<div class="login-container">
  <button
    class="dark-mode-toggle"
    (click)="toggleDarkMode()"
    [attr.aria-label]="isDarkMode() ? 'Activar modo claro' : 'Activar modo oscuro'"
  >
    <lib-icon [name]="isDarkMode() ? 'Sun' : 'Moon'" [size]="20"></lib-icon>
  </button>

  <div class="background-overlay"></div>
  @if (!isMobile) {
    <div
      class="network-background"
      [style.background-image]="
        'url(' +
        (isDarkMode()
          ? 'assets/shell/wallpapers/nebula-background-dark.png'
          : 'assets/shell/wallpapers/nebula-background-light.png') +
        ')'
      "
    ></div>
  }

  <div class="content-wrapper" [class.mobile-view]="isMobile">
    @if (!isMobile) {
      @if (!isTablet) {
        <div class="brand-section"></div>
      }

      <form [formGroup]="form" class="login-form" autocomplete="on" (ngSubmit)="onSubmit()">
        <div class="brand-section">
          <img
            [src]="
              isDarkMode()
                ? 'assets/shell/logos/dark/logo-nebula-dark.svg'
                : 'assets/shell/logos/light/logo-nebula-light.svg'
            "
            alt="Nebula ERP"
            class="logo"
          />
        </div>

        <div class="divider"></div>

        <h2 class="form-title">INICIO DE SESIÓN</h2>

        <lib-input
          formControlName="user"
          loginAutocomplete="username"
          loginInputName="username"
          [required]="true"
          label="Usuario"
          placeholder="Usuario"
          [errorMsg]="getError('user')"
        ></lib-input>

        <lib-input
          formControlName="password"
          loginAutocomplete="current-password"
          loginInputName="password"
          [required]="true"
          type="password"
          label="Clave"
          placeholder="Clave"
          [errorMsg]="getError('password')"
        ></lib-input>

        <section class="submit-wrapper">
          <lib-button
            type="submit"
            [loading]="loading()"
            [disabled]="form.invalid || loading()"
            class="btn-login-submit"
          >
            {{ loading() ? 'Entrando...' : 'Ingresar' }}
          </lib-button>
        </section>
        <br />

        <div class="forgot-password">
          <div class="forgot-text">¿Olvidaste tu clave?</div>
          <a href="#" class="forgot-link">Haz click aquí para recuperarla.</a>
        </div>
      </form>
    }

    @if (isMobile) {
      <div class="mobile-message">
        <img src="assets/shell/logos/logo-nebula.svg" alt="Nebula ERP" class="mobile-logo" />
        <p>Por favor, accede desde una computadora o tablet para continuar</p>
      </div>
    }
  </div>

  @if (!isMobile && error()) {
    <div
      class="global-alert login-error-alert"
      [class.closing]="errorClosing()"
      role="alert"
      aria-live="assertive"
    >
      <div class="login-error-alert__content">
        <div class="login-error-alert__title">{{ error()!.TITLE }}</div>
        <div class="login-error-alert__message">{{ error()!.SUBTITLE }}</div>
      </div>
      <button
        type="button"
        class="login-error-alert__close"
        aria-label="Cerrar alerta"
        (click)="dismissError()"
      >
        <lib-icon name="X" [size]="18" aria-hidden="true"></lib-icon>
      </button>
    </div>
  }
</div>
